export type Network = "bitcoin" | "ethereum" | "solana" | "tron";

const UNIT_CONFIG: Record<Network, { divisor: number; symbol: string; decimals: number }> = {
  bitcoin: { divisor: 100_000_000, symbol: "BTC", decimals: 8 },
  ethereum: { divisor: 1_000_000_000_000_000_000, symbol: "ETH", decimals: 6 },
  solana: { divisor: 1_000_000_000, symbol: "SOL", decimals: 6 },
  tron: { divisor: 1_000_000, symbol: "TRX", decimals: 6 },
};

/** Base-unit amount (satoshis, wei, lamports, or sun) → a human-readable "N.NNN SYMBOL" string. */
export function formatAmount(baseUnits: number, network: Network): string {
  const { divisor, symbol, decimals } = UNIT_CONFIG[network];
  return (baseUnits / divisor).toFixed(decimals) + " " + symbol;
}

export function unitSymbol(network: Network): string {
  return UNIT_CONFIG[network].symbol;
}

export function unitDivisor(network: Network): number {
  return UNIT_CONFIG[network].divisor;
}
